import AgendamentoInterceptor from '@finx/web-repository/src/apis/Agendamento/AgendamentoInterceptor'
// import LegacyInterceptor from '@finx/web-repository/src/apis/Legacy/LegacyInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'
import { ProtocolHistory, HistoricoAlteracaoSolicitacao } from '@/types/_'

const factory = new FactoryResponse()
// const api = new LegacyInterceptor()
const api = new AgendamentoInterceptor()

export default {
  async get(solicitacaoId: string) {
    const request = await api.get(`/solicitacoes-backoffice/${solicitacaoId}/historico`)
    return factory.build(request)
  },

  async getProtocolHistory(surgerySolicitationId: string) {
    const APIRequest = await api.get(`/solicitacoes-backoffice/${surgerySolicitationId}/historico-protocolo`)
    return factory.build<ProtocolHistory[]>(APIRequest)
  },

  async getHistoricoDeAlteracoesDaSolicitacao(solicitacaoId: string) {
    const response = await api.get(`solicitacoes-backoffice/${solicitacaoId}/historico-alteracoes`)
    return factory.build<HistoricoAlteracaoSolicitacao[]>(response)
  },
}
